import type { ChakraProps, SpinnerProps } from '@chakra-ui/react'
import { Box, Spinner } from '@chakra-ui/react'

export const Loading = ({
  large = false,
  text = 'Načítání...',
  sx,
  spinnerProps,
  ...rest
}: {
  large?: boolean,
  text?: string,
  spinnerProps?: SpinnerProps
} & ChakraProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        py: large ? 8 : 0,
        placeContent: 'center',
        placeItems: 'center',
        ...sx
      }}

      {...rest}
    >
      <Spinner {...spinnerProps} />
      {text}
    </Box>
  )
}
